import { KibAmexIcon } from '@chewy/kib-icons-react';
import { KibGiftcardIcon } from '@chewy/kib-icons-react';
import { KibPaypalIcon } from '@chewy/kib-icons-react';
import { KibApplepayIcon } from '@chewy/kib-icons-react';
import { KibGooglepayIcon } from '@chewy/kib-icons-react';
import { KibVenmoIcon } from '@chewy/kib-icons-react';
import { KibDiscoverIcon } from '@chewy/kib-icons-react';
import { KibMastercardIcon } from '@chewy/kib-icons-react';
import { KibVisaIcon } from '@chewy/kib-icons-react';
import { KibChewyPlusCPlusWhiteOnBlueIcon } from '@chewy/kib-icons-react';

export function getPaymentIcon(key: string) {
    if (!key) {
        return null;
    }

    switch (key.toUpperCase()) {
        case 'VISA':
            return <KibVisaIcon />;
        case 'MASTERCARD':
            return <KibMastercardIcon />;
        case 'AMERICANEXPRESS':
            return <KibAmexIcon />;
        case 'DISCOVER':
            return <KibDiscoverIcon />;
        case 'APPLEPAY':
            return <KibApplepayIcon />;
        case 'GOOGLEPAY':
            return <KibGooglepayIcon />;
        case 'PAYPAL':
            return <KibPaypalIcon />;
        case 'CHEWYGIFTCARDS':
            return <KibGiftcardIcon />;
        case 'CHEWYPLUSREWARDS':
            return <KibChewyPlusCPlusWhiteOnBlueIcon />;
        case 'VENMO':
            return <KibVenmoIcon />;
        default:
            return null;
    }
}
